<ycn-modal-base [open]="open" (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
            (closeModalHandler)="closeModal()"
            [header]="'Select Financial Metrics'"
            (resetModalHandler)="resetModal()"
            resetModalText="Reset">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section form-row">
            <ycn-icon-search-autocomplete
                    [searchType]="searchType"
                    [defaultOnly]="defaultOnly"
                    (submitHandler)="submitModalAutocomplete($event)">
            </ycn-icon-search-autocomplete>
        </div>
        <ycn-multi-metric-by-category-list
                [maxMetrics]="maxMetrics"
                [categories]="categories"
                [showInfoPopover]="showInfoPopover"
                (maxLimitReachedHandler)="handleMaxLimitError($event)">
        </ycn-multi-metric-by-category-list>
    </div>
    <ycn-simple-modal-footer
            [errorText]="errorText"
            [selectedItemCount]="selectedItemsCount()"
            (cancelHandler)="closeModal()"
            [disableSubmission]="!isSubmissionEnabled()"
            (submitHandler)="submitModal()"
    ></ycn-simple-modal-footer>
</ycn-modal-base>

<ycn-feature-needed></ycn-feature-needed>
